type BasicType = string | boolean | number

const isoDateFormat =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/

const performTransformations = (data?: BasicType) => {
    if (typeof data === 'string' && isoDateFormat.test(data)) {
        return new Date(data)
    } else return data
}

export const transformData = <T>(object: object): T => {
    const traverse = (node: unknown): unknown => {
        if (Array.isArray(node)) {
            return node.map((entry) => traverse(entry))
        }
        if (typeof node === 'object' && node) {
            return Object.entries(node as object).reduce(
                (acc, [key, value]) => {
                    return {
                        ...acc,
                        [key]: traverse(value),
                    }
                },
                {}
            )
        }
        // leaf found
        return performTransformations(node as BasicType)
    }
    return traverse(object) as unknown as T
}
